import { EMPRESA_LOGGED_IN, EMPRESA_LOGGED_OUT} from '../actions/actionTypes'

const initialState = {
    empresa: null, 
    nomeEmpresa: null
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case EMPRESA_LOGGED_IN:
            return{
                ...state,
                empresa: action.payload.empresa,
                nomeEmpresa: action.payload.nomeEmpresa
            } 
        case EMPRESA_LOGGED_OUT:
            return{
                ...state,
                empresa: null
            }
        default:
            return state
    }
}

export default reducer